(() => {
  const initRoot = (root) => {
    if (root.dataset.giftBoxInitialized) return;
    const form = root.querySelector('product-form-component form');
    if (!form) return;
    root.dataset.giftBoxInitialized = 'true';
    const sectionId = root.dataset.giftBoxSection;
    const emptyText = root.dataset.giftBoxEmpty || 'Not selected';
    const preferenceError = root.querySelector('[data-gift-box-preference-error]');
    const preferences = root.querySelector('[data-gift-box-preferences]');
    const preferenceInput = form.querySelector('[data-gift-box-preference]');
    const character = root.dataset.giftBoxCharacter || '';
    let variantPending = false;
    let variantAvailable = root.dataset.giftBoxAvailable === 'true';

    const value = (selector) => form.querySelector(selector)?.value || '';
    const setSummary = (key, text) => {
      const node = root.querySelector(`[data-gift-box-summary="${key}"]`);
      if (node) node.textContent = text || emptyText;
    };
    const updatePreferences = (changed) => {
      const choices = [...form.querySelectorAll('[data-gift-box-preference-option]')];
      if (changed?.checked && changed.hasAttribute('data-exclusive')) {
        choices.forEach((choice) => { if (choice !== changed) choice.checked = false; });
      } else if (changed?.checked) {
        choices.forEach((choice) => { if (choice.hasAttribute('data-exclusive')) choice.checked = false; });
      }
      preferenceInput.value = choices.filter((choice) => choice.checked).map((choice) => choice.value).join(' & ');
      setSummary('preference', preferenceInput.value);
      if (preferenceInput.value) {
        if (preferenceError) preferenceError.hidden = true;
        preferences?.removeAttribute('aria-invalid');
      }
    };
    const syncCheckout = () => {
      const locked = !character || !preferenceInput.value || variantPending || !variantAvailable || !value('input[name="id"]');
      root.toggleAttribute('data-gift-box-ready', !locked);
      root.querySelectorAll('.accelerated-checkout-block').forEach((node) => {
        node.toggleAttribute('data-gift-box-locked', locked);
      });
    };
    const showError = () => {
      if (!preferenceInput.value) {
        if (preferenceError) preferenceError.hidden = false;
        preferences?.setAttribute('aria-invalid', 'true');
        form.querySelector('[data-gift-box-preference-option]')?.focus();
      }
    };
    const validate = (event) => {
      updatePreferences();
      if (character && preferenceInput.value && !variantPending && variantAvailable && value('input[name="id"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showError();
    };

    form.addEventListener('submit', validate, true);
    root.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      if (event.target.closest('.sticky-add-to-cart__button, .gift-box .add-to-cart-button, .shopify-payment-button')) {
        validate(event);
      }
    }, true);
    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-gift-box-preference-option]')) updatePreferences(event.target);
      setSummary('video', value('[data-gift-box-video]:checked'));
      syncCheckout();
    });
    form.addEventListener('input', (event) => {
      if (event.target.matches('[data-gift-box-avoid]')) setSummary('avoid', event.target.value);
      if (event.target.matches('[data-gift-box-message]')) setSummary('message', event.target.value);
    });

    root.addEventListener('variant:selected', () => {
      variantPending = true;
      syncCheckout();
    });
    root.addEventListener('variant:update', (event) => {
      if (event.detail?.data?.productId !== root.querySelector('product-form-component')?.dataset.productId) return;
      variantPending = false;
      variantAvailable = event.detail?.resource?.available === true;
      const html = event.detail?.data?.html;
      const updated = html?.querySelector(`[data-gift-box-section="${sectionId}"]`);
      setSummary('scoops', updated?.querySelector('[data-gift-box-summary="scoops"]')?.textContent);
      setSummary('gachas', updated?.querySelector('[data-gift-box-summary="gachas"]')?.textContent);
      setSummary('price', updated?.querySelector('[data-gift-box-summary="price"]')?.textContent);
      queueMicrotask(syncCheckout);
    });

    updatePreferences();
    syncCheckout();
  };

  document.querySelectorAll('[data-gift-box]').forEach(initRoot);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-gift-box]').forEach(initRoot);
  });
})();
